function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".book-white_svg__cls-1{fill:#fff;fill-rule:evenodd}"));

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  className: "book-white_svg__cls-1",
  d: "M18.24 22.41a1 1 0 01-1-1V8a1 1 0 012 0v13.39a1 1 0 01-1 1m4.48-7a1 1 0 01-1-1V1a1 1 0 112 0v13.39a1 1 0 01-1 1m4.48 4.13a1 1 0 01-1-1V5.15a1 1 0 012 0v13.37a1 1 0 01-1 1m4.48 4.94a1 1 0 01-1-1V10.09a1 1 0 012 0v13.37a1 1 0 01-1 1m-22.4 1a1 1 0 01-1-1V11.13a1 1 0 012 0V24.5a1 1 0 01-1 1m4.48 7.66a1 1 0 01-1-1V18.8a1 1 0 012 0v13.36a1 1 0 01-1 1m23.89-8.24c2-1.1 3.55-.16 3.55 2.08v17.89a8 8 0 01-3.51 6.17l-13.48 8a7.41 7.41 0 01-3.59.86V38a5.76 5.76 0 012.51-5z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  className: "book-white_svg__cls-1",
  d: "M3.55 24.94C1.6 23.84 0 24.78 0 27v17.91a8 8 0 003.51 6.17l13.48 8a7.44 7.44 0 003.59.86V38a5.78 5.78 0 00-2.5-5z"
});

var SvgBookWhite = function SvgBookWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "book-white_svg__Layer_1",
    width: 42.05,
    height: 60,
    viewBox: "0 0 42.05 60"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNDIuMDUiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA0Mi4wNSA2MCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmY7ZmlsbC1ydWxlOmV2ZW5vZGQ7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAxPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xOC4yNCwyMi40MWExLDEsMCwwLDEtMS0xVjhhMSwxLDAsMCwxLDIsMFYyMS4zOWExLDEsMCwwLDEtMSwxbTQuNDgtN2ExLDEsMCwwLDEtMS0xVjFhMSwxLDAsMSwxLDIsMFYxNC4zOWExLDEsMCwwLDEtMSwxbTQuNDgsNC4xM2ExLDEsMCwwLDEtMS0xVjUuMTVhMSwxLDAsMCwxLDIsMFYxOC41MmExLDEsMCwwLDEtMSwxbTQuNDgsNC45NGExLDEsMCwwLDEtMS0xVjEwLjA5YTEsMSwwLDAsMSwyLDBWMjMuNDZhMSwxLDAsMCwxLTEsMW0tMjIuNCwxYTEsMSwwLDAsMS0xLTFWMTEuMTNhMSwxLDAsMCwxLDIsMFYyNC41YTEsMSwwLDAsMS0xLDFtNC40OCw3LjY2YTEsMSwwLDAsMS0xLTFWMTguOGExLDEsMCwwLDEsMiwwVjMyLjE2YTEsMSwwLDAsMS0xLDFtMjMuODktOC4yNGMyLTEuMSwzLjU1LS4xNiwzLjU1LDIuMDhsMCwxNy44OWE4LDgsMCwwLDEtMy41MSw2LjE3bC0xMy40OCw4YTcuNDEsNy40MSwwLDAsMS0zLjU5Ljg2VjM4YTUuNzYsNS43NiwwLDAsMSwyLjUxLTVaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMy41NSwyNC45NEMxLjYsMjMuODQsMCwyNC43OCwwLDI3TDAsNDQuOTFhOCw4LDAsMCwwLDMuNTEsNi4xN2wxMy40OCw4YTcuNDQsNy40NCwwLDAsMCwzLjU5Ljg2VjM4YTUuNzgsNS43OCwwLDAsMC0yLjUtNVoiLz48L3N2Zz4=";
export { SvgBookWhite as ReactComponent };